import React from 'react';
import { Button } from '@components/atoms/Button';
import { useTranslation } from '@hooks/useTranslation';

interface NonOwnerActionsProps {
  onCreateOrganization: () => void;
  onTryAgain: () => void;
  onLogout: () => void;
  isChecking: boolean;
}

const NonOwnerActions: React.FC<NonOwnerActionsProps> = ({
  onCreateOrganization,
  onTryAgain,
  onLogout,
  isChecking,
}) => {
  // Sprint 28, story-143. Bucket 2 — docs/architecture.md "## Sprint 28" Decision 4.
  const tOrgLifecycle = useTranslation('orgLifecycle');
  return (
    <>
      <p className="text-gray-600 dark:text-gray-400 text-sm text-center mb-6">
        {tOrgLifecycle.nonOwnerSuspendedHint}
      </p>

      <div className="w-full flex flex-col gap-3">
        <Button variant="primary" fullWidth onClick={onCreateOrganization}>
          {tOrgLifecycle.createAnOrganization}
        </Button>

        <Button
          variant="secondary"
          fullWidth
          onClick={onTryAgain}
          disabled={isChecking}>
          {isChecking ? tOrgLifecycle.checking : tOrgLifecycle.tryAgain}
        </Button>

        <Button variant="tertiary" fullWidth onClick={onLogout}>
          {tOrgLifecycle.logout}
        </Button>
      </div>

      <div className="mt-6 p-4 bg-yellow-50 dark:bg-yellow-900/30 rounded-lg">
        <p className="text-xs text-gray-600 dark:text-gray-400 text-center">
          {tOrgLifecycle.nonOwnerErrorHint}
        </p>
        <p className="text-xs text-gray-600 dark:text-gray-400 text-center mt-1">
          {tOrgLifecycle.nonOwnerBillingHint}
        </p>
      </div>
    </>
  );
};

export default NonOwnerActions;
